import { ConfigContext } from '../context';
import ErrorBoundary from '../errorBoundary';

const ConfigProvider = ConfigContext.Provider;

export { ErrorBoundary, ConfigProvider };
